export const checkRoleAccess = (item, role) => {
  return !item.allowedRoles || item.allowedRoles.includes(role);
};

export const checkCategoryAccess = (item, availableCategories) => {
  return !item?.category || item.category === "ALL" || availableCategories?.includes(item.category);
};
